import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    isOpen: boolean = false
    jsonData: any
    jsonDataOrig: any

    @Input('isMobile') isMobile;
    @Input('isHome') isHome;

    constructor(
        private breakpointObserver: BreakpointObserver,
    ) {
        this.jsonDataOrig = {
            fastChannels: [
                { id: 'moviesphere', logo: 'assets/img/menu-v2/top/moviesphere.png', url: '/movie-sphere' },
                { id: '50centaction', logo: 'assets/img/menu-v2/top/50centAction.png', url: '/50centaction' },
                { id: 'hersphere', logo: 'assets/img/menu-v2/top/hersphere.png', url: '/her-sphere' },
                { id: 'ebonytv', logo: 'assets/img/menu-v2/top/ebonytv.png', url: '/ebonytv' },
                { id: 'outersphere', logo: 'assets/img/menu-v2/top/outersphere.png', url: '/outer-sphere' },
                { id: 'lawless', logo: 'assets/img/menu-v2/top/lawless.png', url: '/lawless' },
                { id: 'extreme-jobs', logo: 'assets/img/menu-v2/top/extremejobs.png', url: '/extreme-jobs' },
            ],
            svodChannels: [
                
                // { id: 'lionsgate-plus', logo: 'assets/img/menu-v2/top/lionsgate_plus.png', url: 'https://www.lionsgateplus.com', external: true },
                { id: 'moviesphere-gold', logo: 'assets/img/menu-v2/top/moviesphere_gold.png', url: 'https://MovieSphereGold.com', external: true },
                { id: 'moviesphere-plus', logo: 'assets/img/home/logos/moviesphere-plus-small.png', url: 'https://moviesphereplus.com/', external: true },
                { id: 'lionsgate-plus', logo: 'assets/img/home/logos/lionsgate-plus-logo-small-desktop.png', url: 'https://lionsgateplus.com', external: true },
            ],
            digitnetChannels: [
                { id: 'moviesphere-gold', logo: 'assets/img/menu-v2/top/moviesphere_gold.png', url: 'https://MovieSphereGold.com', external: true },
            ],
            series: [
                { title: 'Designated Survivor', logo: 'assets/img/menu-v2/fast-series/Designated-Survivor.png', url: '/channel/designated-survivor', order: 1, orderMob: 1 },
                { title: 'The Conners', logo: 'assets/img/menu-v2/fast-series/The-Conners.png', url: '/channel/the-conners', order: 2, orderMob: 2 },
                { title: 'Nash Bridges', logo: 'assets/img/menu-v2/fast-series/Nash-Bridges.png', url: '/channel/nash-bridges', order: 3, orderMob: 3 },
                { title: 'Are We There Yet?', logo: 'assets/img/menu-v2/fast-series/are-we-there-yet.png', url: '/channel/are-we-there-yet', order: 4, orderMob: 4 },
                { title: 'Anger Management', logo: 'assets/img/menu-v2/fast-series/Anger-Management.png', url: '/channel/anger-management', order: 5, orderMob: 5 },
                { title: 'Ghost Hunters', logo: 'assets/img/menu-v2/fast-series/Ghost-Hunters.png', url: '/channel/ghost-hunters', order: 6, orderMob: 6 },
                { title: 'Wanted Dead Or Alive', logo: 'assets/img/menu-v2/fast-series/Wanted-Dead-or-Alive.png', url: '/channel/wanted-dead-or-alive', order: 7, orderMob: 7 },
                { title: 'Celebrity Name Game', logo: 'assets/img/menu-v2/fast-series/Celebrity-Name-Game.png', url: '/channel/celebrity-name-game', order: 8, orderMob: 8 },
                { title: 'Caught In Providence', logo: 'assets/img/menu-v2/fast-series/Caught-In-Providence.png', url: '/channel/caught-in-providence', order: 9, orderMob: 9 },
                { title: 'Nashville', logo: 'assets/img/menu-v2/fast-series/Nashville.png', url: '/channel/nashville', order: 10, orderMob: 10 },
                { title: 'Love Thy Neighbor', logo: 'assets/img/menu-v2/fast-series/Love-Thy-Neighbor.png', url: '/channel/love-thy-neighbor', order: 11, orderMob: 11 },
                { title: 'Wendy Williams Show', logo: 'assets/img/menu-v2/fast-series/Wendy.png', url: '/channel/wendy-williams', order: 12, orderMob: 12 },
                { title: 'Weeds and Nurse Jackie', logo: 'assets/img/menu-v2/fast-series/Weeds-and-Nurse-Jackie.png', url: '/channel/weeds-and-nurse-jackie', order: 13, orderMob: 13 },
                { title: 'Heartland', logo: 'assets/img/menu-v2/fast-series/heartland.png', url: '/channel/heartlad', order: 14, orderMob: 14 },
                { title: 'Wicked Tuna', logo: 'assets/img/menu-v2/fast-series/wicked-tuna.png', url: '/channel/weeds-and-nurse-jackie', order: 15, orderMob: 15 },




 




            ]
        }

        breakpointObserver.observe([
            Breakpoints.HandsetLandscape,
            Breakpoints.HandsetPortrait
        ]).subscribe(result => {
            if (result.matches) {
                this.isMobile = true;

                this.jsonData = this.jsonDataOrig           
                this.jsonData.series = this.jsonData.series.sort( (a, b) => a.orderMob - b.orderMob)     
            }
            else {
                this.isMobile = false;
                this.jsonData = this.jsonDataOrig
                this.jsonData.series = this.jsonData.series.sort( (a, b) => {
                    if(!a.order ) return 0
                    if(!b.order) return 0
                    return a.order - b.order 
                })
            }
        });
    }

    ngOnInit(): void {

    }

    onToggleDropdown() {
        if (this.isOpen) {
            this.onClose()
        }
        else {
            this.onOpen()
        }
    }

    onOpen() {
        this.isOpen = true
        document.body.style.overflow = 'hidden'
    }

    onClose() {
        this.isOpen = false
        document.body.style.overflow = ''
    }
}
